interface CartaoResumoProps {
  evento: string;
  modalidade: string;
  grupo: string | null;
  valor: string;
}

export default function CartaoResumo({ evento, modalidade, grupo, valor }: CartaoResumoProps) {
  const partes = [evento, modalidade, grupo, valor].filter(Boolean).join(' · ');

  return (
    <div className="overflow-hidden rounded-lg border border-secondary-200 bg-white">
      <div className="h-[10px] w-full bg-primary-500" />
      <div className="p-4">
        <p className="text-[15px] text-foreground-950">{partes}</p>
      </div>
    </div>
  );
}